// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1dbZD","legacyBtn":"MutateMid_legacyBtn__19RgU"};